module.exports = __webpack_public_path__ + "img/bi_calendar-check.06e6b573.svg";